angular.module('webtrader').controller('AppPage', ($scope, Account, Quotes, Trades, ModalWindow, OpenListOptions, OpenListMarket,
                                                   $window, $location) => {
  if (!Account.info.group.is_options)
    $window.location.href = "/my/webtrader_classic/" + Account.currentLogin
  window.s = $scope;
  $scope.account = Account;
  $scope.quotes = Quotes;
  $scope.trades = Trades;
  $scope.openInvitationModal = () => {
    ModalWindow.open("invitation")
  };
  $scope.openRegistrationModal = () => {
    ModalWindow.open("registration")
  };

  $scope.isOpenOptions = () => {
    let isOpen = OpenListOptions.isOpen;
    return $scope.account.info.group.is_options && isOpen;
  };

  $scope.currentUrl = $location.url().substring(1);

  $scope.isOpenMarketReview = () => {
    let isOpen = OpenListMarket.isOpen;
    return $scope.account.info.group.is_options && isOpen;
  };
});
